export class MaterialsComparer {
    static equals(loadedMaterials: number[], fileMaterials: number[]): boolean {
        return fileMaterials.every(value => loadedMaterials.includes(value));
    }
}